import { h, FunctionComponent } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { useDispatch, useSelector } from 'react-redux';
import { MonetaryInput } from 'up-ops-web-shared-components';
import { trackFormBlur } from '~src/utils/tracking';
import { localeSelector } from '../state/commonSelectors';
import { CurrencyInputProps } from '../types/forms';

/**
  Usage: Currency <input> that formats the value with the currency mask
*/
const CurrencyInput: FunctionComponent<CurrencyInputProps> = ({
  id,
  value,
  isDisabled = false,
  isRequired = false,
  isReadOnly = false,
  className = '',
  placeholder = '',
  onChangeHandler,
  currencyConfig,
  maxLength = 100,
}) => {
  const locale = useSelector(localeSelector);
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const onBlurHandler = () => {
    dispatch(trackFormBlur(id));
    setIsFocused(false);
  };

  const onFocusHandler = () => {
    setIsFocused(true);
  };

  return (
    <MonetaryInput
      id={id}
      ariaLabel='currency input'
      maxLength={maxLength}
      innerRef={inputRef}
      value={value}
      locales={[locale, `en-US`]}
      name={id}
      className={isFocused ? `${className} focused` : className}
      disabled={isDisabled}
      aria-disabled={isDisabled}
      aria-required={isRequired}
      readOnly={isReadOnly}
      placeholder={placeholder}
      currencySymbol={currencyConfig.symbol || '$'}
      symbolPosition={currencyConfig.positionLeft ? 'left' : 'right'}
      onChange={onChangeHandler}
      onBlur={onBlurHandler}
      onFocus={onFocusHandler}
    />
  );
};

export default CurrencyInput;
